import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, " View or modify current Mailing Address and Payment setup", -1)
const _hoisted_3 = { class: "table-item" }
const _hoisted_4 = { class: "table-item" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, {
      success: _ctx.success,
      info: _ctx.info,
      errors: _ctx.errors
    }, null, 8, ["success", "info", "errors"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_TextInput, {
              type: "text",
              name: "mixed",
              label: "My Mailing Address",
              placeholder: "Enter My Mailing Address",
              max: 50,
              modelValue: _ctx.address,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createElementVNode("a", {
              href: "",
              class: "btn btn-secondary plan-modal",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('check-destination', 'Payment Destionation Setup', 'plan-form', 'medicare')), ["prevent"]))
            }, " Change my Mailing Address ")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TextInput, {
              type: "text",
              name: "mixed",
              label: "My Payment Setup Currently is",
              placeholder: "Enter My Payment Setup Currently is",
              max: 50,
              modelValue: _ctx.directDeposit,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.directDeposit) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createElementVNode("a", {
              href: "",
              class: "btn btn-secondary plan-modal",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('check-destination', 'Payment Destionation Setup', 'plan-form', 'medicare')), ["prevent"]))
            }, [
              (_ctx.switchCheck)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Switch to check "))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "Switch to Direct Deposit "))
            ])
          ])
        ]))
  ], 64))
}